import { render, staticRenderFns } from "./RevokeMultiChoiceCardsDialog.vue?vue&type=template&id=2c04e250&"
import script from "./RevokeMultiChoiceCardsDialog.vue?vue&type=script&lang=ts&"
export * from "./RevokeMultiChoiceCardsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RevokeMultiChoiceCardsDialog.vue?vue&type=style&index=0&id=2c04e250&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports